/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spicy_Mushy_Jackdaw_LearnInputs */

const fr_spicy_mushy_jackdaw_learn = /** @type {(inputs: Spicy_Mushy_Jackdaw_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(facultatif)`)
};

/**

* @param {Spicy_Mushy_Jackdaw_LearnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spicy_mushy_jackdaw_learn = /** @type {((inputs?: Spicy_Mushy_Jackdaw_LearnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spicy_Mushy_Jackdaw_LearnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spicy_mushy_jackdaw_learn(inputs)
});